import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { SUPPLEMENT_PRESETS } from '../../data/store';
import { FiPlus, FiX } from 'react-icons/fi';

export default function StepSupplements({ data, onChange }) {
  const [customName, setCustomName] = useState('');
  const [customDose, setCustomDose] = useState('');
  
  const supplements = data.supplements || [];

  const toggle = (name) => {
    const exists = supplements.find(s => s.name === name);
    if (exists) {
      onChange({ supplements: supplements.filter(s => s.name !== name) });
    } else {
      onChange({ supplements: [...supplements, { name, dose: '' }] });
    }
  };

  const addCustom = () => {
    if (!customName.trim()) return;
    const name = customName.trim();
    if (supplements.find(s => s.name === name)) return;
    
    onChange({ supplements: [...supplements, { name, dose: customDose.trim() }] });
    setCustomName('');
    setCustomDose('');
  };

  const remove = (name) => onChange({ supplements: supplements.filter(s => s.name !== name) });

  return (
    <div className="space-y-6">
      <p className="font-sans text-sm text-slate-500">What supplements did you take today?</p>
      
      <div className="flex flex-wrap gap-2">
        {SUPPLEMENT_PRESETS.map(s => {
          const active = supplements.some(x => x.name === s);
          return (
            <button
              key={s}
              onClick={() => toggle(s)}
              className={`px-4 py-2.5 rounded-full text-sm font-sans font-medium transition-all active:scale-95 ${
                active 
                  ? 'bg-slate-900 text-white' 
                  : 'glass-input text-slate-700'
              }`}
            >
              {active ? '✓ ' : ''}{s}
            </button>
          );
        })}
      </div>

      <div className="glass-card rounded-[2rem] p-5 space-y-3">
        <p className="font-sans text-xs font-semibold text-slate-400 uppercase tracking-widest">Add Custom</p>
        <div className="flex gap-2">
          <input
            value={customName}
            onChange={e => setCustomName(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') addCustom(); }}
            placeholder="Name"
            className="flex-1 text-sm font-sans glass-input rounded-full px-4 py-3 focus:outline-none text-slate-800 placeholder:text-slate-400"
          />
          <input
            value={customDose}
            onChange={e => setCustomDose(e.target.value)}
            placeholder="Dose"
            className="w-20 text-sm font-sans glass-input rounded-full px-3 py-3 focus:outline-none text-slate-800 placeholder:text-slate-400 text-center"
          />
          <button
            onClick={addCustom}
            className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center text-white flex-shrink-0 active:scale-95 transition-transform"
          >
            <SafeIcon icon={FiPlus} className="text-lg" />
          </button>
        </div>
      </div>

      {supplements.length > 0 && (
        <div className="space-y-2 pt-2">
          {supplements.map((s, i) => (
            <div key={i} className="flex items-center justify-between glass-card rounded-2xl px-5 py-4 border-[#e5e1f9]">
              <div>
                <span className="font-sans text-base font-medium text-slate-800">{s.name}</span>
                {s.dose && <span className="font-sans text-xs text-slate-500 ml-3 bg-white/50 px-2 py-1 rounded-full">{s.dose}</span>}
              </div>
              <button 
                onClick={() => remove(s.name)} 
                className="w-8 h-8 rounded-full bg-white/60 flex items-center justify-center text-slate-400 active:scale-95"
              >
                <SafeIcon icon={FiX} className="text-lg" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}